import React from 'react';
import ReactDOM from 'react-dom';

import { Provider } from 'react-redux';
import { createBrowserHistory } from 'history';
import { ConnectedRouter } from 'connected-react-router';
import { PersistGate } from 'redux-persist/integration/react';

import { I18n } from '@aws-amplify/core'
import { vocabularies } from './amplifyVocabularies'

import theme from './theme';
import { ThemeProvider } from '@material-ui/styles';

import configureStore from './configureStore';
import * as serviceWorker from './serviceWorker';
import App from './App';

I18n.putVocabularies(vocabularies)
I18n.setLanguage('ja')

const history = createBrowserHistory();
const [store, persistor] = configureStore(history);

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <ThemeProvider theme={theme}>
        < ConnectedRouter history={history}>
          <App />,
        </ConnectedRouter>
      </ThemeProvider>
    </PersistGate>
  </Provider>,
  document.getElementById('root')
);

serviceWorker.unregister();
